/**
 * Hide Chatty (Ask launcher + popup) while Focal cart drawer is open,
 * so it cannot cover Checkout / free-shipping / cart CTAs (esp. mobile).
 * Restores Chatty when the drawer closes.
 */
(function () {
  var CART_SEL = 'cart-drawer#mini-cart, cart-drawer.mini-cart, cart-drawer';

  function isCartOpen() {
    var el = document.querySelector(CART_SEL);
    return !!(el && el.hasAttribute('open'));
  }

  function chattyDo(cmd) {
    window.$chatty = window.$chatty || [];
    window.$chatty.push(['do', cmd]);
  }

  function syncChattyToCart() {
    var open = isCartOpen();
    document.documentElement.classList.toggle('pt-cart-open', open);
    if (document.body) document.body.classList.toggle('pt-cart-open', open);

    if (open) {
      chattyDo('chat:close');
      chattyDo('chat:hide');
    } else {
      chattyDo('chat:show');
    }
  }

  function bindCart(el) {
    if (!el || el.dataset.ptChattyCartBound === '1') return;
    el.dataset.ptChattyCartBound = '1';
    el.addEventListener('openable-element:open', syncChattyToCart);
    el.addEventListener('openable-element:close', syncChattyToCart);
    new MutationObserver(syncChattyToCart).observe(el, {
      attributes: true,
      attributeFilter: ['open']
    });
  }

  function init() {
    document.querySelectorAll(CART_SEL).forEach(bindCart);
    syncChattyToCart();
  }

  document.addEventListener(
    'openable-element:open',
    function (e) {
      if (e.target && e.target.matches && e.target.matches('cart-drawer')) {
        bindCart(e.target);
        syncChattyToCart();
      }
    },
    true
  );
  document.addEventListener(
    'openable-element:close',
    function (e) {
      if (e.target && e.target.matches && e.target.matches('cart-drawer')) {
        syncChattyToCart();
      }
    },
    true
  );

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Section reloads / late mini-cart
  new MutationObserver(function () {
    document.querySelectorAll(CART_SEL).forEach(bindCart);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();

/**
 * Option-1 W1 — ShippingEstimator helpers (cart page only).
 * Decorates Focal's shipping-estimator CE: empty-zip guard + max async poll attempts.
 * Does NOT rewrite theme.js. Does NOT touch Chatty cart-open hide above.
 */
(function () {
  var MAX_POLL_ATTEMPTS = 20;
  var POLL_DELAY_MS = 350;

  function str(key, fallback) {
    try {
      var s = window.themeVariables && window.themeVariables.strings;
      if (s && s[key]) return s[key];
    } catch (e) {}
    return fallback;
  }

  function showLocalError(estimatorEl, message) {
    if (!estimatorEl) return;
    var existing = estimatorEl.querySelector('.shipping-estimator__results');
    if (existing) existing.remove();
    var status = estimatorEl.querySelector('.pt-shipping-estimator__status');
    var html =
      '<div class="shipping-estimator__results shipping-estimator__results--error">' +
      '<p>' +
      message +
      '</p></div>';
    estimatorEl.insertAdjacentHTML('beforeend', html);
    if (status) status.textContent = message;
  }

  function clearStatus(estimatorEl) {
    var status = estimatorEl && estimatorEl.querySelector('.pt-shipping-estimator__status');
    if (status) status.textContent = '';
  }

  function patchPrototype(Ctor) {
    var proto = Ctor.prototype;
    if (proto.__ptShippingUxPatched) return;
    proto.__ptShippingUxPatched = true;

    var origEstimate = proto._estimateShipping;
    var origPoll = proto._getAsyncShippingRates;

    proto._estimateShipping = async function () {
      var zipInput = this.querySelector('[name="shipping-estimator[zip]"]');
      var zip = zipInput && zipInput.value ? String(zipInput.value).trim() : '';
      clearStatus(this);
      if (!zip) {
        if (this.submitButton) this.submitButton.removeAttribute('aria-busy');
        showLocalError(
          this,
          str('shippingEstimatorZipRequired', 'Please enter a zip / postal code.')
        );
        if (zipInput) {
          zipInput.setAttribute('aria-invalid', 'true');
          try {
            zipInput.focus();
          } catch (e) {}
        }
        return;
      }
      if (zipInput) zipInput.removeAttribute('aria-invalid');
      try {
        return await origEstimate.call(this);
      } catch (err) {
        showLocalError(
          this,
          str('shippingEstimatorTimeout', 'Shipping rates are taking longer than expected. Please try again.')
        );
        if (this.submitButton) this.submitButton.removeAttribute('aria-busy');
      }
    };

    proto._getAsyncShippingRates = async function (zip, country, province, attempt) {
      attempt = typeof attempt === 'number' ? attempt : 0;
      var cartUrl =
        (window.themeVariables &&
          window.themeVariables.routes &&
          window.themeVariables.routes.cartUrl) ||
        '/cart';
      var response = await fetch(
        cartUrl +
          '/async_shipping_rates.json?shipping_address[zip]=' +
          encodeURIComponent(zip) +
          '&shipping_address[country]=' +
          encodeURIComponent(country) +
          '&shipping_address[province]=' +
          encodeURIComponent(province)
      );
      var responseAsText = await response.text();
      if (responseAsText === 'null') {
        if (attempt >= MAX_POLL_ATTEMPTS) {
          throw new Error('pt-shipping-rates-timeout');
        }
        await new Promise(function (resolve) {
          setTimeout(resolve, POLL_DELAY_MS);
        });
        return this._getAsyncShippingRates(zip, country, province, attempt + 1);
      }
      return JSON.parse(responseAsText)['shipping_rates'];
    };

    // Prefer patched poll even if origEstimate calls origPoll via closure — we replaced proto methods.
    // Keep reference so unused lint stays quiet.
    void origPoll;
  }

  function tryPatch() {
    var Ctor = window.customElements && customElements.get('shipping-estimator');
    if (!Ctor) return false;
    patchPrototype(Ctor);
    return true;
  }

  function boot() {
    if (tryPatch()) return;
    var tries = 0;
    var id = setInterval(function () {
      tries += 1;
      if (tryPatch() || tries > 40) clearInterval(id);
    }, 100);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

/**
 * Option-1 live-control follow-up — surface ZIP/state errors and explain $0 rates.
 * APPEND-ONLY: observes theme-injected estimator results without rewriting theme.js.
 */
(function () {
  var ZIP_STATE_ERROR_RE = /(zip|postal).*(valid|match|state|province)|(state|province).*(zip|postal|valid|match)|(valid).*(zip|postal)/i;
  var FREE_RATE_RE = /(?:[$€£]\s*0(?:[.,]00)?\b|\b0(?:[.,]00)\b|\bfree\b)/i;

  function estimatorFor(node) {
    return node && (node.closest('shipping-estimator') || node.closest('.shipping-estimator'));
  }

  function revealEstimator(estimatorEl, target) {
    if (!estimatorEl) return;
    var collapsible = estimatorEl.closest('collapsible-content');
    if (collapsible) {
      collapsible.setAttribute('open', '');
      collapsible.removeAttribute('hidden');
      if (collapsible.id) {
        var toggle = document.querySelector('[aria-controls="' + collapsible.id + '"]');
        if (toggle) toggle.setAttribute('aria-expanded', 'true');
      }
    }
    var scrollTarget = target || estimatorEl.querySelector('.pt-shipping-estimator__status') || estimatorEl;
    if (scrollTarget && scrollTarget.scrollIntoView) {
      var raf = window.requestAnimationFrame || function (callback) { setTimeout(callback, 0); };
      raf(function () {
        try {
          scrollTarget.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
        } catch (e) {
          scrollTarget.scrollIntoView();
        }
      });
    }
  }

  function isUnderFreeShippingThreshold() {
    var bars = document.querySelectorAll('free-shipping-bar[threshold]');
    for (var i = 0; i < bars.length; i += 1) {
      var bar = bars[i];
      var threshold = parseFloat(bar.getAttribute('threshold'));
      var total = parseFloat(bar.getAttribute('data-cart-total-cents'));
      if (isFinite(threshold) && isFinite(total)) return total < threshold;

      var progress = parseFloat(window.getComputedStyle(bar).getPropertyValue('--progress'));
      if (isFinite(threshold) && isFinite(progress)) return progress < 1;
    }
    return false;
  }

  function addFreeRateNote(results) {
    if (!results || !isUnderFreeShippingThreshold() || !FREE_RATE_RE.test(results.textContent || '')) return;
    if (results.querySelector('[data-pt-free-rate-note]')) return;
    var note = document.createElement('p');
    note.className = 'pt-shipping-estimator__free-rate-note text--subdued text--small';
    note.setAttribute('data-pt-free-rate-note', '');
    note.textContent = str('shippingEstimatorFreeRateUnderThreshold', 'A $0 rate may only apply once you reach free shipping.');
    results.appendChild(note);
  }

  function str(key, fallback) {
    try {
      var strings = window.themeVariables && window.themeVariables.strings;
      if (strings && strings[key]) return strings[key];
    } catch (e) {}
    return fallback;
  }

  function handleResults(results) {
    var estimatorEl = estimatorFor(results);
    var text = results.textContent || '';
    if (ZIP_STATE_ERROR_RE.test(text)) revealEstimator(estimatorEl, results);
    addFreeRateNote(results);
  }

  function scanResults(root) {
    if (!root || !root.querySelectorAll) return;
    if (root.matches && root.matches('.shipping-estimator__results')) handleResults(root);
    root.querySelectorAll('.shipping-estimator__results').forEach(handleResults);
  }

  function boot() {
    scanResults(document);
    if (!document.body) return;

  function mutationsForResultTarget(target) {
    var element = target && (target.nodeType === 1 ? target : target.parentElement);
    var results = element && (element.matches && element.matches('.shipping-estimator__results')
      ? element
      : element.closest && element.closest('.shipping-estimator__results'));
    if (results) handleResults(results);
  }
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutationsForResultTarget(mutation.target);
        mutation.addedNodes.forEach(scanResults);
      });
    }).observe(document.body, { childList: true, characterData: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

/**
 * Drawer Estimate follow-up — keep rate results / ZIP errors visible in mini-cart footer.
 * APPEND-ONLY. Does NOT rewrite theme.js. Does NOT touch Chatty cart-open hide IIFE.
 * ShippingEstimator + country-selector already re-init via connectedCallback when
 * cart-drawer replaces innerHTML on cart:refresh / cart:updated.
 */
(function () {
  function scrollDrawerEstimatorIntoView(node) {
    if (!node || !node.closest) return;
    var drawer = node.closest('cart-drawer');
    if (!drawer) return;
    var footer = drawer.querySelector('.mini-cart__drawer-footer');
    var target =
      (node.closest && node.closest('.shipping-estimator__results')) ||
      (node.closest && node.closest('.pt-shipping-estimator__status')) ||
      node;
    if (footer && typeof footer.scrollTop === 'number' && target && footer.contains(target)) {
      try {
        var footerRect = footer.getBoundingClientRect();
        var targetRect = target.getBoundingClientRect();
        var delta = targetRect.top - footerRect.top - 8;
        footer.scrollTop = Math.max(0, footer.scrollTop + delta);
      } catch (e) {}
      return;
    }
    if (target && target.scrollIntoView) {
      try {
        target.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
      } catch (e2) {
        target.scrollIntoView();
      }
    }
  }

  function watch() {
    if (!document.body) return;
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (!node || node.nodeType !== 1) return;
          if (
            (node.matches && node.matches('.shipping-estimator__results, .pt-shipping-estimator__status')) ||
            (node.querySelector && node.querySelector('.shipping-estimator__results, .pt-shipping-estimator__status'))
          ) {
            var hit =
              (node.matches && node.matches('.shipping-estimator__results') && node) ||
              (node.querySelector && node.querySelector('.shipping-estimator__results')) ||
              node;
            scrollDrawerEstimatorIntoView(hit);
          }
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
})();

/**
 * ZIP-only Estimate (preview) — derive US state from ZIP before ShippingEstimator fetch.
 * APPEND-ONLY after Option-1 helpers + drawer scroll helper.
 * Does NOT rewrite theme.js. Does NOT touch Chatty cart-open hide IIFE.
 * No geolocation API.
 *
 * Scope: .shipping-estimator--zip-only on drawer and /cart.
 * Empty ZIP → leave Option-1 empty-zip guard alone.
 * Unmapped ZIP → local error (no state dropdown).
 * Mapped ZIP → set hidden country=United States + province=code, then continue.
 */
(function () {
  var US_COUNTRY = 'United States';

  /* Inclusive ZIP3 prefix ranges → USPS state / DC codes (Shopify province option values). */
  var ZIP3_RANGES = [
    [5, 5, 'NY'],
    [10, 27, 'MA'],
    [28, 29, 'RI'],
    [30, 38, 'NH'],
    [39, 49, 'ME'],
    [50, 59, 'VT'],
    [60, 69, 'CT'],
    [70, 89, 'NJ'],
    [100, 149, 'NY'],
    [150, 196, 'PA'],
    [197, 199, 'DE'],
    [200, 200, 'DC'],
    [201, 201, 'VA'],
    [202, 205, 'DC'],
    [206, 219, 'MD'],
    [220, 246, 'VA'],
    [247, 268, 'WV'],
    [269, 269, 'MI'],
    [270, 289, 'NC'],
    [290, 299, 'SC'],
    [300, 319, 'GA'],
    [320, 339, 'FL'],
    [341, 349, 'FL'],
    [350, 369, 'AL'],
    [370, 385, 'TN'],
    [386, 397, 'MS'],
    [398, 399, 'GA'],
    [400, 427, 'KY'],
    [430, 459, 'OH'],
    [460, 479, 'IN'],
    [480, 499, 'MI'],
    [500, 528, 'IA'],
    [530, 549, 'WI'],
    [550, 567, 'MN'],
    [570, 577, 'SD'],
    [580, 588, 'ND'],
    [590, 599, 'MT'],
    [600, 629, 'IL'],
    [630, 658, 'MO'],
    [660, 679, 'KS'],
    [680, 693, 'NE'],
    [700, 715, 'LA'],
    [716, 729, 'AR'],
    [730, 731, 'OK'],
    [733, 733, 'TX'],
    [734, 749, 'OK'],
    [750, 799, 'TX'],
    [800, 816, 'CO'],
    [820, 831, 'WY'],
    [832, 838, 'ID'],
    [840, 847, 'UT'],
    [850, 865, 'AZ'],
    [870, 884, 'NM'],
    [889, 898, 'NV'],
    [900, 961, 'CA'],
    [967, 968, 'HI'],
    [970, 979, 'OR'],
    [980, 994, 'WA'],
    [995, 999, 'AK']
  ];

  function str(key, fallback) {
    try {
      var s = window.themeVariables && window.themeVariables.strings;
      if (s && s[key]) return s[key];
    } catch (e) {}
    return fallback;
  }

  function normalizeZip(raw) {
    if (!raw) return '';
    var digits = String(raw).replace(/\D/g, '');
    if (digits.length >= 5) return digits.slice(0, 5);
    return digits;
  }

  function stateFromZip(zip5) {
    if (!zip5 || zip5.length < 3) return null;
    var prefix = parseInt(zip5.slice(0, 3), 10);
    if (isNaN(prefix)) return null;
    for (var i = 0; i < ZIP3_RANGES.length; i++) {
      var row = ZIP3_RANGES[i];
      if (prefix >= row[0] && prefix <= row[1]) return row[2];
    }
    return null;
  }

  function showLocalError(estimatorEl, message) {
    if (!estimatorEl) return;
    var existing = estimatorEl.querySelector('.shipping-estimator__results');
    if (existing) existing.remove();
    var status = estimatorEl.querySelector('.pt-shipping-estimator__status');
    var html =
      '<div class="shipping-estimator__results shipping-estimator__results--error">' +
      '<p>' +
      message +
      '</p></div>';
    estimatorEl.insertAdjacentHTML('beforeend', html);
    if (status) status.textContent = message;
  }

  function ensureCountryUnitedStates(countrySelect) {
    if (!countrySelect || !countrySelect.options) return false;
    var i;
    for (i = 0; i < countrySelect.options.length; i++) {
      var opt = countrySelect.options[i];
      if (opt.text === US_COUNTRY || opt.value === US_COUNTRY || opt.value === 'US') {
        if (countrySelect.selectedIndex !== i) {
          countrySelect.selectedIndex = i;
          try {
            countrySelect.dispatchEvent(new Event('change', { bubbles: true }));
          } catch (e) {
            var ev = document.createEvent('HTMLEvents');
            ev.initEvent('change', true, false);
            countrySelect.dispatchEvent(ev);
          }
        } else if (countrySelect.provinceElement || countrySelect.getAttribute('aria-owns')) {
          /* Provinces may already be populated from connectedCallback */
        }
        return true;
      }
    }
    return false;
  }

  function setProvinceCode(provinceSelect, code) {
    if (!provinceSelect || !code) return false;
    var i;
    for (i = 0; i < provinceSelect.options.length; i++) {
      var opt = provinceSelect.options[i];
      if (opt.value === code || opt.text === code) {
        provinceSelect.selectedIndex = i;
        return true;
      }
    }
    /* Options not ready (or code missing) — inject so .value is readable by theme.js */
    try {
      provinceSelect.options.add(new Option(code, code, true, true));
      provinceSelect.value = code;
      return true;
    } catch (e2) {
      return false;
    }
  }

  function applyZipDerivedAddress(estimatorEl, zip5, stateCode) {
    var countrySelect = estimatorEl.querySelector('[name="shipping-estimator[country]"]');
    var provinceSelect = estimatorEl.querySelector('[name="shipping-estimator[province]"]');
    ensureCountryUnitedStates(countrySelect);
    /* CountrySelector rebuilds province options on change — re-query and set */
    provinceSelect = estimatorEl.querySelector('[name="shipping-estimator[province]"]');
    return setProvinceCode(provinceSelect, stateCode);
  }

  function isZipOnlyEstimator(el) {
    if (!el || !el.closest) return false;
    return !!el.closest('.shipping-estimator--zip-only');
  }

  function patchPrototype(Ctor) {
    var proto = Ctor.prototype;
    if (proto.__ptZipOnlyPatched) return;
    proto.__ptZipOnlyPatched = true;

    var prevEstimate = proto._estimateShipping;

    proto._estimateShipping = async function () {
      if (!isZipOnlyEstimator(this)) {
        return prevEstimate.call(this);
      }

      var zipInput = this.querySelector('[name="shipping-estimator[zip]"]');
      var raw = zipInput && zipInput.value ? String(zipInput.value).trim() : '';
      var zip5 = normalizeZip(raw);

      /* Empty ZIP: Option-1 empty-zip guard handles messaging — do not map */
      if (!zip5) {
        return prevEstimate.call(this);
      }

      var stateCode = stateFromZip(zip5);
      if (!stateCode) {
        if (this.submitButton) this.submitButton.removeAttribute('aria-busy');
        showLocalError(
          this,
          str('shippingEstimatorZipUnmapped', 'Enter a valid US ZIP code.')
        );
        if (zipInput) {
          zipInput.setAttribute('aria-invalid', 'true');
          try {
            zipInput.focus();
          } catch (e) {}
        }
        return;
      }

      if (zipInput) zipInput.removeAttribute('aria-invalid');
      applyZipDerivedAddress(this, zip5, stateCode);
      return prevEstimate.call(this);
    };
  }

  function boot() {
    var Ctor = window.customElements && window.customElements.get('shipping-estimator');
    if (Ctor) {
      patchPrototype(Ctor);
      return;
    }
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('shipping-estimator').then(function () {
        patchPrototype(customElements.get('shipping-estimator'));
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

/* ------------------------------------------------------------------
 * P1-1 (2026-09-28): "With Subscription" card link -> shared
 * DiffuserDiscount-info-Modal (overlay group, pt-modal-assets opens it).
 * Adds focus return: when a pt-modal closes, focus goes back to the
 * link/button that opened it. Append-only; does not touch theme.js.
 * ------------------------------------------------------------------ */
(function () {
  if (window.__ptSubModalPatched) return;
  window.__ptSubModalPatched = true;

  var lastTrigger = {};

  function esc(v) {
    if (window.CSS && CSS.escape) return CSS.escape(v);
    return String(v).replace(/["\\]/g, '\\$&');
  }

  function watch(modal, id) {
    if (modal.__ptFocusObs) return;
    modal.__ptFocusObs = new MutationObserver(function () {
      if (modal.classList.contains('is-open')) {
        modal.__ptWasOpen = true;
        return;
      }
      if (!modal.__ptWasOpen) return;
      modal.__ptWasOpen = false;
      var t = lastTrigger[id];
      if (t && document.documentElement.contains(t)) {
        try { t.focus({ preventScroll: true }); } catch (e) { t.focus(); }
      }
    });
    modal.__ptFocusObs.observe(modal, { attributes: true, attributeFilter: ['class'] });
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var trigger = target.closest('[data-modal-trigger], a[href*="#"]');
    if (!trigger || trigger.closest('[data-pt-modal-id]')) return;
    var raw = trigger.getAttribute('data-modal-trigger') || '';
    if (!raw) {
      var href = trigger.getAttribute('href') || '';
      raw = href.indexOf('#') > -1 ? href.split('#').pop() : '';
    }
    var id = String(raw).trim().replace(/^#/, '');
    if (!id) return;
    var modal = document.querySelector('[data-pt-modal-id="' + esc(id) + '"]');
    if (!modal) return;
    lastTrigger[id] = trigger;
    watch(modal, id);
    /* pt-modal-assets' capture listener may already have opened it. */
    if (modal.classList.contains('is-open')) modal.__ptWasOpen = true;
  }, true);
})();

/* ------------------------------------------------------------------
 * P2-3 (2026-09-28): free-shipping nudge live update.
 * The drawer section re-renders the nudge (Liquid) on cart:refresh;
 * this keeps it correct in between (and wherever no re-render runs)
 * using the AFTER-discount cart.total_price from cart:updated, and
 * overrides Focal's free-shipping-bar progress (pre-cart-discount).
 * ------------------------------------------------------------------ */
(function () {
  if (window.__ptFsNudgePatched) return;
  window.__ptFsNudgePatched = true;

  function formatMoney(cents, currency) {
    var fmt = (window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.moneyFormat) || '';
    var value = (Number(cents) || 0) / 100;
    var m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    if (!m) {
      try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency || 'USD' }).format(value); } catch (e) { return value.toFixed(2); }
    }
    function group(num, decimals, thousands, dec) {
      var parts = num.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.join(parts[1] !== undefined ? dec : '');
    }
    var out;
    switch (m[1]) {
      case 'amount_no_decimals': out = group(value, 0, ',', '.'); break;
      case 'amount_with_comma_separator': out = group(value, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': out = group(value, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': out = group(value, 2, "'", '.'); break;
      default: out = group(value, 2, ',', '.');
    }
    return fmt.replace(m[0], out);
  }

  /* 2026-09-30: attribute text may carry HTML entities (Liquid `t` escapes, e.g. You&#39;ve);
     decode before inserting as text so the bar never shows a raw entity. RCDATA parse = no markup. */
  var decoder = document.createElement('textarea');
  function decode(str) {
    str = String(str || '');
    if (!/&(#\d+|#x[0-9a-f]+|[a-z][a-z0-9]*);/i.test(str)) return str;
    decoder.innerHTML = str;
    return decoder.value;
  }

  function update(cart) {
    if (!cart || typeof cart.total_price !== 'number') return;
    var total = cart.total_price;
    (cart.items || []).forEach(function (item) {
      if (!item.requires_shipping) total -= item.final_line_price || 0;
    });
    if (total < 0) total = 0;
    document.querySelectorAll('[data-pt-fs-nudge]').forEach(function (root) {
      var bar = root.querySelector('free-shipping-bar[threshold]');
      if (!bar) return;
      var threshold = parseFloat(bar.getAttribute('threshold'));
      if (!isFinite(threshold) || threshold <= 0) return;
      var unlocked = total >= threshold;
      bar.setAttribute('data-cart-total-cents', String(total));
      bar.style.setProperty('--progress', String(Math.min(total / threshold, 1)));
      root.classList.toggle('is-unlocked', unlocked);
      var text = root.querySelector('[data-pt-fs-text]');
      if (text) {
        if (unlocked) {
          text.textContent = decode(root.getAttribute('data-text-unlocked'));
        } else {
          var tpl = decode(root.getAttribute('data-text-remaining'));
          text.textContent = tpl.replace('__PT_AMT__', formatMoney(threshold - total, cart.currency));
        }
      }
      var note = root.querySelector('[data-pt-fs-note]');
      if (note) note.textContent = decode(root.getAttribute(unlocked ? 'data-note-unlocked' : 'data-note-under')) || note.textContent;
    });
  }

  document.documentElement.addEventListener('cart:updated', function (event) {
    var cart = event && event.detail && event.detail.cart;
    /* run after Focal's own free-shipping-bar handler */
    setTimeout(function () { update(cart); }, 0);
  });
})();

/* ------------------------------------------------------------------
 * Realtors (2026-09-29): keep the Realtor_Kit_N code in step with the
 * number of realtor-kit units in the cart, sitewide (drawer + /cart).
 * The bundle builder (blocks/ai_gen_block_f0f9463.liquid, section
 * 178785885399aee125 on page.realtors.json) applies the tier code for
 * the cart total after an add; this re-checks it after drawer quantity
 * changes / removals (Focal fires cart:updated + cart:refresh on
 * document.documentElement) and on /cart page load (Focal reloads the
 * cart page after a quantity change).
 * Acts when a Realtor_Kit_* code is on the cart; keeps every other
 * code; removes the Realtor code (and the builder marker) when kit units
 * fall below the lowest tier. Re-entry guarded; never retries the same
 * correction. (2026-09-29 pm) Builder carts (cart attribute
 * _pt_realtor_tier) whose code was dropped because it stopped qualifying
 * get the right tier re-applied; never fights another code.
 * Tiers/product ids come from the block (window.__ptRealtorKitConfig or
 * its localStorage copy); DEFAULT_TIERS mirror the block settings in
 * templates/page.realtors.json -- update both if the tiers change.
 * (2026-09-30) Quantity changes in the drawer / on /cart are taken over for kit carts: quantity +
 * tier code + marker go in ONE /cart/update.js with the drawer section and the drawer is patched
 * in place once (no second render, no full-drawer flash). Carts with kits but no code get the
 * tier on load / drawer open when no other code is on the cart. Marker 'off' = stood down.
 * (2026-09-30 pm) System codes = codes the theme's own bundle/offer blocks apply via
 * /discount/<code> (Make a Bundle M5FYSA1YV0DE etc.). In carts with kit units they are swapped for
 * the Realtor tier (in the same single request), and a block's /discount/<system code> fetch in a kit
 * cart applies the tier instead. Codes the shopper entered are never touched. No kits left -> no
 * Realtor code, marker cleared, system codes left alone (normal Make a Bundle carts unchanged).
 * (2026-09-30 pm2) Checkout: Shopify forwards the discount_code cookie (set by /discount/<code>) to
 * checkout, where it beats the cart's codes. In kit carts the cookie is kept on the Realtor tier
 * (system/stale codes overwritten, a shopper's own code left alone) and every cart checkout submit
 * (drawer button, /cart button, Enter) first settles the cart + cookie, then submits as usual.
 * (2026-09-30 pm3) Fail-open: every async step we insert (fetch intercept, quantity take-over,
 * checkout guard, reconcile) is time-boxed and falls through to the original behaviour; the
 * realtors builder's Add to Cart has a watchdog that always finishes with the button reset and
 * the drawer open (XHR, independent of the fetch() wrapper chain), also after a bfcache restore.
 * (2026-09-30 pm4) Builder Add to Cart fast path: one /cart/add.js carrying the drawer section ->
 * the drawer renders + opens right away (~1 request); the tier (code + marker) follows in one
 * /cart/update.js and patches the open drawer in place once. It never blocks the drawer.
 * ------------------------------------------------------------------ */
(function () {
  if (window.__ptRealtorTierPatched) return;
  window.__ptRealtorTierPatched = true;

  var DEFAULT_TIERS = [
    { quantity: 1, code: 'Realtor_Kit_1' },
    { quantity: 3, code: 'Realtor_Kit_2' },
    { quantity: 7, code: 'Realtor_Kit_3' },
    { quantity: 10, code: 'Realtor_Kit_4' }
  ];
  var DEFAULT_COLLECTION = 'realtor-collection';
  var CONFIG_KEY = 'pt-realtor-kit-config-v1';
  var IDS_KEY = 'pt-realtor-kit-ids-v1';
  var ATTEMPT_KEY = 'pt-realtor-kit-attempt-v1';
  var REALTOR_RE = /^realtor_kit_/i;
  /* Builder marker: cart attribute (underscore = hidden at checkout) holding the Realtor code the
     builder / this script last applied. Set by blocks/ai_gen_block_f0f9463.liquid on add.
     (2026-09-30) 'off' = we stood down for this cart (shopper removed the code / another code won):
     never auto-apply again until the kits leave the cart or the builder sets a code again. */
  var MARK_ATTR = '_pt_realtor_tier';
  var MARK_OFF = 'off';
  var HINT_KEY = 'pt-realtor-builder-v1';
  /* (2026-09-30 pm) System codes. Seed = every non-Realtor discount code set in block settings
     across templates/*.json on 2026-09-30 (bundle / oil / upsell / sale-page blocks). Kept current at
     runtime from the blocks' data attributes on any page this browser renders and from any
     /discount/<code> the page's own JS fetches (stored in localStorage). */
  var SEED_SYSTEM_CODES = ['M5FYSA1YV0DE', '0K13P0J840HM', 'BUNDLE_9EJDUTL', 'CompanionSpring40', '3KWND4F9M926', '9RJ6S0ZK2XB0', 'FathersDay_2026', 'MemorialDay_2026'];
  var SYSTEM_KEY = 'pt-system-codes-v1';
  var SYSTEM_ATTRS = ['data-discount-code', 'data-oil-to-diffuser-discount-code', 'data-oil-to-oil-discount-code',
    'data-tier1-code', 'data-tier2-code', 'data-tier3-code'];

  var busy = false;
  var again = false;
  var selfDispatch = false;
  var timer = null;
  var lastCart = null; /* last cart JSON seen (events / our own requests) */
  var queue = Promise.resolve(); /* serialises intercepted quantity changes */

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function validConfig(cfg) {
    return !!(cfg && Array.isArray(cfg.tiers) && cfg.tiers.length);
  }

  function getConfig() {
    var cfg = window.__ptRealtorKitConfig;
    if (!validConfig(cfg)) {
      try { cfg = JSON.parse(window.localStorage.getItem(CONFIG_KEY) || 'null'); } catch (e) { cfg = null; }
    }
    if (!validConfig(cfg)) cfg = { tiers: DEFAULT_TIERS, collection: DEFAULT_COLLECTION, productIds: [] };
    return cfg;
  }

  /* Synchronous view of the kit product ids (block config or session cache); null if unknown yet. */
  function knownIds(cfg) {
    if (cfg.productIds && cfg.productIds.length) return cfg.productIds.map(String);
    try {
      var cached = JSON.parse(window.sessionStorage.getItem(IDS_KEY) || 'null');
      if (cached && cached.length) return cached;
    } catch (e) {}
    return null;
  }

  function getProductIds(cfg) {
    var known = knownIds(cfg);
    if (known) return Promise.resolve(known);
    var handle = cfg.collection || DEFAULT_COLLECTION;
    return fetch(root() + 'collections/' + encodeURIComponent(handle) + '/products.json?limit=250', {
      headers: { Accept: 'application/json' }
    }).then(function (r) { return r.ok ? r.json() : { products: [] }; }).then(function (data) {
      var ids = ((data && data.products) || []).map(function (p) { return String(p.id); });
      if (ids.length) {
        try { window.sessionStorage.setItem(IDS_KEY, JSON.stringify(ids)); } catch (e) {}
      }
      return ids;
    });
  }

  function kitUnits(cart, ids) {
    return ((cart && cart.items) || []).reduce(function (sum, line) {
      return ids.indexOf(String(line.product_id)) > -1 ? sum + (parseInt(line.quantity, 10) || 0) : sum;
    }, 0);
  }

  function isRealtorCode(code, tiers) {
    if (!code) return false;
    var lower = String(code).toLowerCase();
    return REALTOR_RE.test(code) || tiers.some(function (t) { return t.code && String(t.code).toLowerCase() === lower; });
  }

  function storedSystem() {
    try {
      var list = JSON.parse(window.localStorage.getItem(SYSTEM_KEY) || '[]');
      return Array.isArray(list) ? list : [];
    } catch (e) { return []; }
  }

  function rememberSystem(codes, tiers) {
    var list = storedSystem();
    var seen = {};
    list.concat(SEED_SYSTEM_CODES).forEach(function (c) { seen[String(c).toLowerCase()] = true; });
    var added = false;
    codes.forEach(function (c) {
      c = String(c || '').trim();
      if (!c || isRealtorCode(c, tiers) || seen[c.toLowerCase()]) return;
      seen[c.toLowerCase()] = true;
      list.push(c);
      added = true;
    });
    if (!added) return;
    try { window.localStorage.setItem(SYSTEM_KEY, JSON.stringify(list.slice(-50))); } catch (e) {}
  }

  /* Read the codes the page's bundle / offer blocks would apply (their data attributes). */
  function harvestSystem(tiers) {
    var codes = [];
    try {
      var sel = SYSTEM_ATTRS.map(function (a) { return '[' + a + ']'; }).join(',');
      Array.prototype.forEach.call(document.querySelectorAll(sel), function (el) {
        SYSTEM_ATTRS.forEach(function (a) { var v = el.getAttribute(a); if (v) codes.push(v); });
      });
    } catch (e) {}
    rememberSystem(codes, tiers);
  }

  function isSystemCode(code, tiers) {
    if (!code || isRealtorCode(code, tiers)) return false;
    /* Landing-page offer codes are never swapped for a Realtor tier (2026-10-09). */
    if (/^(3KWND4F9M926|9RJ6S0ZK2XB0)$/i.test(String(code))) return false;
    var lower = String(code).toLowerCase();
    return SEED_SYSTEM_CODES.concat(storedSystem()).some(function (c) { return String(c).toLowerCase() === lower; });
  }

  /* ---------- (2026-09-30 pm2) discount_code cookie (not HttpOnly; host-only, path=/) ---------- */
  var COOKIE = 'discount_code';
  function readCookie() {
    var hit = ('; ' + document.cookie).split('; ' + COOKIE + '=')[1];
    if (hit === undefined) return '';
    try { return decodeURIComponent(hit.split(';')[0]); } catch (e) { return hit.split(';')[0]; }
  }
  function writeCookie(value) {
    document.cookie = COOKIE + '=' + (value ? encodeURIComponent(value) : '') + '; path=/; SameSite=Lax' + (value ? '' : '; max-age=0');
  }
  /* Kit cart: the cookie carries the cart's Realtor tier (overwrites a system / stale Realtor code;
     created only when the cart has no shopper code; a shopper's own cookie code is left alone), and
     a system code never stays in it. No kits: a leftover Realtor code is dropped; theme codes stay. */
  function syncCookie(cart, units, tiers) {
    if (!cart || !Array.isArray(cart.discount_codes)) return;
    var cur = readCookie();
    var codes = cartCodes(cart);
    if (units > 0) {
      var tier = codes.filter(function (c) { return isRealtorCode(c, tiers); })[0] || '';
      var shopper = codes.filter(function (c) { return !isRealtorCode(c, tiers) && !isSystemCode(c, tiers); });
      /* (2026-10-09) The cookie follows the code that APPLIES: a page-offer code that does not apply
         (NCO in a kit-only cart) is ours to replace; one that applies is never overwritten, and a
         Realtor tier that does not apply is never written. */
      var appl = applicableMap(cart);
      var offerIdle = /^(3KWND4F9M926|9RJ6S0ZK2XB0)$/i.test(cur) && appl[cur.toLowerCase()] === false;
      var ours = !cur || isRealtorCode(cur, tiers) || isSystemCode(cur, tiers) || offerIdle;
      if (tier && appl[tier.toLowerCase()] !== false) {
        if (ours && cur.toLowerCase() !== tier.toLowerCase() && (cur || !shopper.length)) writeCookie(tier);
      } else if (!tier && cur && ours) {
        writeCookie('');
      }
    } else if (cur && isRealtorCode(cur, tiers)) {
      writeCookie('');
    }
  }

  function tierCodeFor(units, tiers) {
    var code = '';
    tiers.slice().sort(function (a, b) { return a.quantity - b.quantity; }).forEach(function (t) {
      if (t.code && units >= Number(t.quantity)) code = t.code;
    });
    return code;
  }

  function cartCodes(cart) {
    return ((cart && cart.discount_codes) || []).map(function (d) { return d && d.code; }).filter(Boolean);
  }

  function getJSON(url) {
    return fetch(url, { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); });
  }

  function tierMinFor(code, tiers) {
    var lower = String(code || '').toLowerCase();
    var hit = tiers.filter(function (t) { return t.code && String(t.code).toLowerCase() === lower; })[0];
    return hit ? Number(hit.quantity) : NaN;
  }

  function setHint(on) {
    try {
      if (on) window.localStorage.setItem(HINT_KEY, '1');
      else window.localStorage.removeItem(HINT_KEY);
    } catch (e) {}
  }

  function hasHint() {
    try { return window.localStorage.getItem(HINT_KEY) === '1'; } catch (e) { return false; }
  }

  function postUpdate(body) {
    return fetch(root() + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.ok ? r.json() : null; });
  }

  /* (2026-09-30 pm3) Time-box a step we inserted; on timeout the caller falls back. */
  var STEP_MS = 6000;
  function timeBox(promise, ms) {
    return new Promise(function (resolve, reject) {
      var t = setTimeout(function () { reject(new Error('pt-timeout')); }, ms || STEP_MS);
      Promise.resolve(promise).then(function (v) { clearTimeout(t); resolve(v); }, function (e) { clearTimeout(t); reject(e); });
    });
  }

  function applicableMap(cart) {
    var map = {};
    ((cart && cart.discount_codes) || []).forEach(function (d) {
      if (d && d.code) map[String(d.code).toLowerCase()] = !!d.applicable;
    });
    return map;
  }

  /* Decide what the cart's discount list + builder marker should be.
     marker (cart attribute MARK_ATTR) = the Realtor code the builder / this script last applied.
     Returns null when nothing needs to change. reapply:true = verify the added code applied and
     knocked nothing out, else undo (never fight another code). */
  function plan(cart, units, tiers) {
    var codes = cartCodes(cart);
    var realtor = codes.filter(function (code) { return isRealtorCode(code, tiers); });
    /* (2026-09-30 pm) with kit units, theme-applied bundle codes are ours to replace */
    var system = units ? codes.filter(function (code) { return isSystemCode(code, tiers); }) : [];
    var others = codes.filter(function (code) { return !isRealtorCode(code, tiers) && system.indexOf(code) === -1; });
    var marker = String((cart.attributes && cart.attributes[MARK_ATTR]) || '');
    var want = tierCodeFor(units, tiers);

    /* (2026-10-09) A page-offer / shopper code applies and no Realtor code does: that code won.
       Stand down (marker off) and leave the codes alone. */
    var appl = applicableMap(cart);
    if (realtor.length && !system.length && marker !== MARK_OFF &&
        others.some(function (c) { return appl[c.toLowerCase()]; }) &&
        !realtor.some(function (c) { return appl[c.toLowerCase()]; })) {
      return { codes: codes, next: codes, marker: MARK_OFF, markerWas: marker, reapply: false };
    }

    if (realtor.length || system.length) {
      /* A Realtor (or, in a kit cart, a system) code is on the cart: keep the Realtor tier matched to
         the kit units, drop system codes. No kits left -> no Realtor code and no marker. */
      var nextMarker = !want ? '' : (system.length || (marker && marker !== MARK_OFF)) ? want : marker;
      if (want && !system.length && realtor.length === 1 && realtor[0].toLowerCase() === want.toLowerCase()) {
        return nextMarker === marker ? null : { codes: codes, next: codes, marker: nextMarker, markerWas: marker, reapply: false };
      }
      return { codes: codes, next: want ? others.concat(want) : others, marker: nextMarker, markerWas: marker, reapply: false };
    }

    if (!units) {
      /* No kits and no Realtor code: forget any marker so a later kit cart starts fresh. */
      return marker ? { codes: codes, next: codes, marker: '', markerWas: marker, reapply: false } : null;
    }

    if (!marker) {
      /* (2026-09-30) Kits in the cart but no tier code (e.g. first drawer open / page load): apply the
         tier -- only when the cart has NO other code, so we never fight a code the shopper entered. */
      if (want && !codes.length) return { codes: codes, next: [want], marker: want, markerWas: marker, reapply: true };
      return null;
    }

    if (marker === MARK_OFF) return null;

    /* Builder cart whose Realtor code is gone. Re-apply ONLY if it was dropped because it stopped
       qualifying (kit units fell below that code's minimum, e.g. a quantity typed in the drawer +
       Enter goes straight to checkout, and checkout drops the no-longer-valid code). If the code
       would still have qualified, the shopper removed it or another code won: stand down for good. */
    var min = tierMinFor(marker, tiers);
    if (want && isFinite(min) && units < min) {
      return { codes: codes, next: codes.concat(want), marker: want, markerWas: marker, reapply: true };
    }
    return { codes: codes, next: codes, marker: MARK_OFF, markerWas: marker, reapply: false };
  }

  /* The body for /cart/update.js that carries a plan (null = nothing to send). */
  function planBody(p) {
    if (!p) return null;
    var discountChanges = p.next.join(',') !== p.codes.join(',');
    var markerChanges = p.marker !== p.markerWas;
    if (!discountChanges && !markerChanges) return null;
    var body = { attributes: {} };
    body.attributes[MARK_ATTR] = p.marker;
    if (discountChanges) body.discount = p.next.join(',');
    return { body: body, discountChanges: discountChanges };
  }

  /* After a reapply/auto-apply: the Realtor code must be applicable and must not have knocked a
     previously-applicable code out. */
  function reapplyOk(p, before, updated) {
    var b = applicableMap(before);
    var a = applicableMap(updated);
    return a[String(p.marker).toLowerCase()] === true && p.codes.every(function (code) {
      var k = String(code).toLowerCase();
      return !b[k] || a[k] === true;
    });
  }

  function undoBody(p, sections) {
    var undo = { discount: p.codes.join(','), attributes: {} };
    undo.attributes[MARK_ATTR] = MARK_OFF;
    if (sections) undo.sections = sections;
    return undo;
  }

  function drawerEl() {
    return document.querySelector('cart-drawer#mini-cart') || document.getElementById('mini-cart');
  }

  function drawerSection() {
    var d = drawerEl();
    return d ? d.getAttribute('section') || 'mini-cart' : '';
  }

  function isCartPage() {
    var settings = (window.themeVariables && window.themeVariables.settings) || {};
    return settings.pageType === 'cart';
  }

  /* ---------- in-place drawer render (no full innerHTML swap -> no blank/flash) ---------- */
  function textSig(el) {
    var s = '';
    for (var n = el.firstChild; n; n = n.nextSibling) {
      if (n.nodeType === 3) s += n.nodeValue;
      else if (n.nodeType === 1) s += '<' + n.tagName + '>';
    }
    return s;
  }

  function syncAttrs(a, b) {
    var i;
    for (i = a.attributes.length - 1; i >= 0; i--) {
      if (!b.hasAttribute(a.attributes[i].name)) a.removeAttribute(a.attributes[i].name);
    }
    for (i = 0; i < b.attributes.length; i++) {
      if (a.getAttribute(b.attributes[i].name) !== b.attributes[i].value) a.setAttribute(b.attributes[i].name, b.attributes[i].value);
    }
  }

  /* Reuse already-decoded <img> nodes for identical images so replaced line items don't blink. */
  function keepImages(oldRoot, newRoot) {
    var pool = {};
    Array.prototype.forEach.call(oldRoot.querySelectorAll ? oldRoot.querySelectorAll('img') : [], function (img) {
      if (!img.complete) return;
      var k = (img.getAttribute('src') || '') + '|' + (img.getAttribute('srcset') || '');
      (pool[k] = pool[k] || []).push(img);
    });
    Array.prototype.forEach.call(newRoot.querySelectorAll('img'), function (img) {
      var k = (img.getAttribute('src') || '') + '|' + (img.getAttribute('srcset') || '');
      var old = pool[k] && pool[k].shift();
      if (old) { syncAttrs(old, img); img.replaceWith(old); }
    });
  }

  function patchChildren(oldEl, newEl, depth) {
    if (depth <= 0 || textSig(oldEl) !== textSig(newEl)) {
      keepImages(oldEl, newEl);
      oldEl.replaceChildren.apply(oldEl, Array.prototype.slice.call(newEl.childNodes));
      return;
    }
    var ol = Array.prototype.slice.call(oldEl.children);
    var nl = Array.prototype.slice.call(newEl.children);
    for (var i = 0; i < ol.length; i++) {
      var a = ol[i];
      var b = nl[i];
      if (a.outerHTML === b.outerHTML) continue;
      /* JS-filled recommendations: keep the populated element if it's for the same product */
      if (a.tagName === 'CART-DRAWER-RECOMMENDATIONS' && a.getAttribute('product-id') === b.getAttribute('product-id')) continue;
      /* never recurse into custom elements (they cache child refs in connectedCallback) */
      if (a.tagName.indexOf('-') === -1 && a.tagName === b.tagName && b.children.length) {
        syncAttrs(a, b);
        patchChildren(a, b, depth - 1);
      } else {
        keepImages(a, b);
        a.replaceWith(b);
      }
    }
  }

  /* Render the drawer from section HTML in place; false if it couldn't (caller falls back). */
  function patchDrawer(html) {
    var drawer = drawerEl();
    if (!drawer || !html) return false;
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var fresh = tmp.querySelector('cart-drawer');
    if (!fresh) return false;
    patchChildren(drawer, fresh, 6);
    return true;
  }

  function sectionHtml(cart) {
    var s = cart && cart.sections;
    var id = drawerSection();
    return s && (s[id] || s['mini-cart']) || '';
  }

  /* One visible update: patch the drawer in place, then tell everyone else (count bubble, nudge,
     builder counts) via cart:updated. No cart:refresh -> Focal doesn't innerHTML the drawer again. */
  function renderCart(updated) {
    lastCart = updated;
    var html = sectionHtml(updated);
    var patched = patchDrawer(html);
    var detail = { cart: updated };
    selfDispatch = true;
    try {
      document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: detail }));
      if (!patched) document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: detail }));
    } finally {
      selfDispatch = false;
    }
  }

  function reconcile() {
    if (busy) { again = true; return Promise.resolve(); }
    busy = true;
    var cfg = getConfig();
    var tiers = cfg.tiers;
    var cart;

    return timeBox(getJSON(root() + 'cart.js').then(function (c) {
      cart = c;
      lastCart = c;
      var hasRealtor = cartCodes(cart).some(function (code) { return isRealtorCode(code, tiers); });
      var hasMarker = !!(cart.attributes && cart.attributes[MARK_ATTR]);
      if (!hasRealtor && !hasMarker && !(cart.items || []).length) { setHint(false); return null; }

      return getProductIds(cfg).then(function (ids) {
        if (!ids.length) return null;
        var units = kitUnits(cart, ids);
        var p = plan(cart, units, tiers);
        var pb = planBody(p);
        syncCookie(cart, units, tiers); /* refreshed again below if the codes change */
        if (!pb) return null;

        /* Don't repeat a correction that already ran for this exact cart state (loop guard,
           survives the /cart page reload). */
        var signature = [cart.token, units, p.codes.join(','), p.next.join(','), p.markerWas, p.marker].join('|');
        try {
          if (window.sessionStorage.getItem(ATTEMPT_KEY) === signature) return null;
          window.sessionStorage.setItem(ATTEMPT_KEY, signature);
        } catch (e) {
          if (reconcile.__last === signature) return null;
        }
        reconcile.__last = signature;

        var body = pb.body;
        if (pb.discountChanges && drawerEl() && !isCartPage()) body.sections = drawerSection();

        return postUpdate(body).then(function (updated) {
          if (!updated || typeof updated.item_count !== 'number') return null;

          if (p.reapply && !reapplyOk(p, cart, updated)) {
            setHint(false);
            return postUpdate(undoBody(p, body.sections)).then(function (reverted) {
              syncCookie(reverted || updated, units, tiers);
              return finish(reverted || updated, true);
            });
          }
          syncCookie(updated, kitUnits(updated, ids), tiers);

          setHint(!!p.marker && p.marker !== MARK_OFF);
          /* Applied as asked -> clear the guard so the same correction can run again later.
             Not applied (Shopify refused the list) -> keep it so we never loop. */
          var got = cartCodes(updated).map(function (c) { return c.toLowerCase(); }).sort().join(',');
          var asked = p.next.map(function (c) { return c.toLowerCase(); }).sort().join(',');
          if (got === asked) {
            try { window.sessionStorage.removeItem(ATTEMPT_KEY); } catch (e) {}
            reconcile.__last = null;
          }
          return finish(updated, pb.discountChanges);
        });
      });
    }), STEP_MS * 2).catch(function () { return null; }).then(function () {
      busy = false;
      if (again) { again = false; schedule(); }
    });
  }

  /* Refresh the drawer (or reload /cart) only when the discount list actually changed;
     a marker-only write is invisible and needs no refresh. */
  function finish(updated, refresh) {
    if (!updated || typeof updated.item_count !== 'number') return null;
    lastCart = updated;
    if (!refresh) return null;
    if (isCartPage()) {
      window.location.reload();
      return null;
    }
    renderCart(updated);
    return null;
  }

  function schedule(delay) {
    clearTimeout(timer);
    timer = setTimeout(reconcile, delay == null ? 400 : delay);
  }

  function onCartEvent(event) {
    if (selfDispatch) return;
    var cart = event && event.detail && event.detail.cart;
    if (cart && Array.isArray(cart.items)) lastCart = cart;
    /* Cheap pre-check: a cart with no Realtor code, no builder marker and (as far as we know) no
       kit units needs nothing. */
    if (cart && Array.isArray(cart.discount_codes)) {
      var cfg = getConfig();
      var tiers = cfg.tiers;
      var marked = !!(cart.attributes && cart.attributes[MARK_ATTR]);
      var ids = knownIds(cfg);
      var kits = ids ? kitUnits(cart, ids) > 0 : !!(cart.items && cart.items.length);
      if (!marked && !kits && !cartCodes(cart).some(function (code) { return isRealtorCode(code, tiers); })) return;
    }
    schedule();
  }

  document.documentElement.addEventListener('cart:updated', onCartEvent);
  document.documentElement.addEventListener('cart:refresh', onCartEvent);

  /* ---------- (2026-09-30) quantity changes: tier + quantity in ONE request, ONE render ----------
     Focal's line-item-quantity posts /cart/change.js and re-renders the drawer (innerHTML); the tier
     swap then posted again and re-rendered again (2 renders + flash, ~2-4 s). For carts with kits /
     a Realtor code / a marker we take the change over (capture phase, before Focal's handler): read
     the cart, plan the tier for the NEW quantity, send quantity + discount + marker together to
     /cart/update.js with the drawer section, and patch the drawer once in place. /cart: one reload.
     Anything unexpected -> Focal's own handler (_updateFromLink) runs as before. */
  function relevant(cart) {
    if (!cart || !Array.isArray(cart.items)) return false;
    var cfg = getConfig();
    var ids = knownIds(cfg);
    if (!ids) return false;
    var marker = cart.attributes && cart.attributes[MARK_ATTR];
    return kitUnits(cart, ids) > 0 || !!marker || cartCodes(cart).some(function (code) { return isRealtorCode(code, cfg.tiers); });
  }

  function parseChange(href) {
    try {
      var u = new URL(href, window.location.origin);
      var q = parseInt(u.searchParams.get('quantity'), 10);
      if (!isFinite(q) || q < 0) return null;
      return { line: parseInt(u.searchParams.get('line'), 10) || 0, id: u.searchParams.get('id') || '', quantity: q };
    } catch (e) { return null; }
  }

  function findItem(cart, ch) {
    var items = cart.items || [];
    if (ch.id) {
      return items.filter(function (it) { return it.key === ch.id || String(it.variant_id) === String(ch.id) || String(it.id) === String(ch.id); })[0] || null;
    }
    return items[ch.line - 1] || null;
  }

  function takeOver(lq, ch, fallbackHref) {
    var fallback = function () {
      if (typeof lq._updateFromLink === 'function') return lq._updateFromLink(fallbackHref);
      window.location.href = fallbackHref;
    };
    lq.dispatchEvent(new CustomEvent('line-item-quantity:change:start', { bubbles: true, detail: { newLineQuantity: ch.quantity } }));
    queue = queue.then(function () {
      var cfg = getConfig();
      var tiers = cfg.tiers;
      var ids = knownIds(cfg) || [];
      busy = true; /* keep reconcile out while we own the cart */
      var settled = false;
      return timeBox(getJSON(root() + 'cart.js').then(function (cart) {
        var item = findItem(cart, ch);
        if (!item) throw new Error('line not found');
        var sim = JSON.parse(JSON.stringify(cart));
        findItem(sim, ch).quantity = ch.quantity;
        var p = plan(sim, kitUnits(sim, ids), tiers);
        var pb = planBody(p);
        var body = pb ? pb.body : {};
        body.updates = {};
        body.updates[item.key] = ch.quantity;
        var onCart = isCartPage();
        if (!onCart) body.sections = drawerSection();
        return postUpdate(body).then(function (updated) {
          if (!updated || typeof updated.item_count !== 'number') throw new Error('update failed');
          if (p && p.reapply && pb && !reapplyOk(p, sim, updated)) {
            return postUpdate(undoBody(p, body.sections)).then(function (reverted) { return reverted || updated; });
          }
          if (p && p.marker) setHint(p.marker !== MARK_OFF);
          return updated;
        }).then(function (updated) {
          syncCookie(updated, kitUnits(updated, ids), tiers);
          busy = false;
          if (onCart) { window.location.reload(); return; }
          lq.dispatchEvent(new CustomEvent('line-item-quantity:change:end', { bubbles: true, detail: { cart: updated, newLineQuantity: ch.quantity } }));
          renderCart(updated);
          /* quantity capped by stock etc. -> the tier may not match the real cart: re-check */
          if (kitUnits(updated, ids) !== kitUnits(sim, ids)) schedule(0);
        });
      }).then(function () { settled = true; }), STEP_MS).catch(function () {
        busy = false;
        if (settled) return;
        settled = true;
        lq.dispatchEvent(new CustomEvent('line-item-quantity:change:end', { bubbles: true }));
        return fallback();
      });
    });
  }

  function interceptable(target) {
    var lq = target && target.closest && target.closest('line-item-quantity');
    if (!lq || typeof lq._updateFromLink !== 'function') return null;
    if (!relevant(lastCart)) return null;
    return lq;
  }

  document.addEventListener('click', function (event) {
    var a = event.target && event.target.closest && event.target.closest('a[href]');
    if (!a) return;
    var lq = interceptable(a);
    if (!lq) return;
    var ch = parseChange(a.href);
    if (!ch) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    takeOver(lq, ch, a.href);
  }, true);

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input || !input.matches || !input.matches('input[data-line]')) return;
    var lq = interceptable(input);
    if (!lq) return;
    var href = ((window.themeVariables && window.themeVariables.routes && window.themeVariables.routes.cartChangeUrl) || '/cart/change') +
      '?quantity=' + encodeURIComponent(input.value) + '&line=' + encodeURIComponent(input.getAttribute('data-line'));
    var ch = parseChange(href);
    if (!ch) return;
    event.stopImmediatePropagation();
    takeOver(lq, ch, href);
  }, true);

  /* (2026-09-30 pm) Bundle / offer blocks apply their code with fetch('/discount/<code>'). In a cart
     with kit units the Realtor tier governs: apply the tier (dropping system codes) instead of the
     block's code. Carts without kits (normal Make a Bundle) go through untouched. */
  var nativeFetch = window.fetch;
  function discountCodeOf(input, init) {
    var method = (init && init.method) || (input && typeof input === 'object' && input.method) || 'GET';
    if (String(method).toUpperCase() !== 'GET') return '';
    var raw = typeof input === 'string' ? input : input && (input.url || input.href) || '';
    if (!raw || String(raw).indexOf('discount/') === -1) return '';
    var u = new URL(String(raw), window.location.origin);
    if (u.origin !== window.location.origin) return '';
    var m = u.pathname.match(/^(?:\/[a-z]{2}(?:-[a-z]{2,4})?)?\/discount\/([^\/]+)\/?$/i);
    return m ? decodeURIComponent(m[1]) : '';
  }
  if (typeof nativeFetch === 'function') {
    window.fetch = function (input, init) {
      var self = this;
      var args = arguments;
      var code = '';
      try { code = discountCodeOf(input, init); } catch (e) { code = ''; }
      var cfg = code ? getConfig() : null;
      if (!code || isRealtorCode(code, cfg.tiers)) return nativeFetch.apply(self, args);
      var tiers = cfg.tiers;
      rememberSystem([code], tiers);
      return timeBox(getProductIds(cfg).then(function (ids) {
        return getJSON(root() + 'cart.js').then(function (cart) {
          var units = ids.length ? kitUnits(cart, ids) : 0;
          if (!units) return nativeFetch.apply(self, args);
          var sim = JSON.parse(JSON.stringify(cart));
          sim.discount_codes = (sim.discount_codes || []).concat([{ code: code, applicable: true }]);
          var p = plan(sim, units, tiers);
          var pb = planBody(p);
          if (pb) pb.body.discount = p.next.join(','); /* the block's code never reaches the cart */
          return (pb ? postUpdate(pb.body) : Promise.resolve(cart)).then(function (updated) {
            if (updated && typeof updated.item_count === 'number') lastCart = updated;
            if (p && p.marker) setHint(p.marker !== MARK_OFF);
            syncCookie(updated && updated.discount_codes ? updated : cart, units, tiers);
            return new Response('', { status: 200, headers: { 'Content-Type': 'text/html' } });
          });
        });
      })).catch(function () { return nativeFetch.apply(self, args); });
    };
  }

  /* (2026-09-30 pm2) Checkout guard. Cart forms (drawer #mini-cart-form, /cart .cart__recap) post
     to /cart with `checkout` and Shopify redirects to checkout carrying the discount_code cookie.
     In kit carts: hold the submit, settle the cart codes (system codes -> tier) + the cookie, then
     submit the same form natively. Carts without kits are never held (stock Focal checkout). */
  var releasing = false;
  function isCheckoutSubmit(form, submitter) {
    if (!form || String(form.method).toLowerCase() !== 'post') return false;
    var action = form.getAttribute('action') || '';
    if (!/\/cart\/?(?:[?#].*)?$/.test(action)) return false;
    return !!((submitter && submitter.name === 'checkout') || form.querySelector('input[name="checkout"]'));
  }
  function prepareCheckout() {
    var cfg = getConfig();
    var tiers = cfg.tiers;
    return getProductIds(cfg).then(function (ids) {
      return getJSON(root() + 'cart.js').then(function (cart) {
        var units = ids.length ? kitUnits(cart, ids) : 0;
        var p = units ? plan(cart, units, tiers) : null;
        var pb = planBody(p);
        if (!pb) { syncCookie(cart, units, tiers); return; }
        return postUpdate(pb.body).then(function (updated) {
          if (!updated || typeof updated.item_count !== 'number') { syncCookie(cart, units, tiers); return; }
          var done = p.reapply && !reapplyOk(p, cart, updated) ? postUpdate(undoBody(p)) : Promise.resolve(updated);
          return done.then(function (final) { lastCart = final || updated; syncCookie(final || updated, units, tiers); });
        });
      });
    });
  }
  document.addEventListener('submit', function (event) {
    if (releasing) return;
    var form = event.target;
    var submitter = event.submitter || null;
    if (!isCheckoutSubmit(form, submitter)) return;
    if (!relevant(lastCart)) {
      /* not a kit cart (as far as we know): stock checkout, just never leak a Realtor code */
      if (lastCart) syncCookie(lastCart, 0, getConfig().tiers);
      return;
    }
    event.preventDefault();
    event.stopImmediatePropagation();
    var buttons = Array.prototype.slice.call(document.querySelectorAll('button[name="checkout"]'));
    buttons.forEach(function (b) { b.setAttribute('aria-busy', 'true'); });
    var release = function () {
      releasing = true;
      buttons.forEach(function (b) { b.removeAttribute('aria-busy'); });
      if (!form.querySelector('input[name="checkout"]')) {
        var hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.name = 'checkout';
        form.appendChild(hidden);
      }
      try { HTMLFormElement.prototype.submit.call(form); } finally { releasing = false; }
    };
    queue = queue.then(function () { return timeBox(prepareCheckout()); }).then(release, release);
  }, true);

  /* Drawer opened: make sure the tier is right (covers carts that got kits without a tier code). */
  document.addEventListener('openable-element:open', function (e) {
    if (e.target && e.target.matches && e.target.matches('cart-drawer')) schedule(0);
  }, true);

  /* On load: /cart (Focal reloads it after quantity changes / checkout returns there), builder
     shoppers (localStorage hint), and any non-empty cart (kits without a tier code get it before the
     drawer is ever opened). Empty carts pay nothing. */
  function onLoad() {
    harvestSystem(getConfig().tiers);
    var count = document.querySelector('cart-count');
    var n = count ? parseInt(count.textContent, 10) : NaN;
    if (isCartPage() || hasHint() || !(n === 0)) schedule(0);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onLoad);
  } else {
    onLoad();
  }

  /* ---------- (2026-09-30 pm3) realtors builder Add to Cart watchdog ----------
     blocks/ai_gen_block_f0f9463.liquid awaits cart/add -> cart.js -> cart/update.js through the page's
     fetch() wrapper chain (Appstle, Elevar, Visually, upsell apps, ours). If that flow hasn't finished
     WATCH_MS after the click (button still "Adding to cart...", page not left), finish it here over XHR:
     tier + marker + drawer section in one /cart/update.js, reset the builder like its own success path,
     render + open the drawer. A never-added selection just gets its button back plus an error. */
  var WATCH_MS = 6000;

  function xhrJSON(method, url, body) {
    return new Promise(function (resolve, reject) {
      var x = new XMLHttpRequest();
      x.open(method, url, true);
      x.setRequestHeader('Accept', 'application/json');
      if (body) x.setRequestHeader('Content-Type', 'application/json');
      x.timeout = STEP_MS;
      x.onload = function () {
        if (x.status < 200 || x.status >= 300) return reject(new Error('HTTP ' + x.status));
        try { resolve(JSON.parse(x.responseText)); } catch (e) { reject(e); }
      };
      x.onerror = x.ontimeout = x.onabort = function () { reject(new Error('xhr failed')); };
      x.send(body ? JSON.stringify(body) : null);
    });
  }

  function builderOf(el) {
    for (var n = el; n && n !== document.documentElement; n = n.parentElement) {
      if (Array.isArray(n.cards) && typeof n.updateAll === 'function' && typeof n.addToCart === 'function') return n;
    }
    return null;
  }

  function isAdding(builder, btn) {
    var adding = String(builder.addingButtonText || 'Adding to cart').replace(/[.\u2026]+$/, '');
    return btn.disabled && btn.textContent.indexOf(adding) > -1;
  }

  function resetBuilder(builder, btn, cart, added) {
    try {
      if (added) {
        builder.cards.forEach(function (it) { it.quantity = 0; if (it.input) it.input.value = 0; });
        if (cart && typeof builder.countKitUnits === 'function') builder.cartKitUnits = builder.countKitUnits(cart);
      }
      builder.updateAll();
    } catch (e) {}
    if (isAdding(builder, btn)) { btn.disabled = false; btn.textContent = builder.addButtonText || 'Add to Cart'; }
  }

  function openDrawer() {
    var d = drawerEl();
    if (!d) return;
    if (!d.hasAttribute('open')) {
      try { d.open = true; } catch (e) { d.setAttribute('open', ''); }
    }
  }

  function rescueBuilder(builder, btn, wanted, unitsBefore) {
    if (builder.__ptRescuing) return;
    builder.__ptRescuing = true;
    var cfg = getConfig();
    var tiers = cfg.tiers;
    var done = function () { builder.__ptRescuing = false; };
    xhrJSON('GET', root() + 'cart.js').then(function (cart) {
      var ids = knownIds(cfg);
      var units = ids ? kitUnits(cart, ids) : (typeof builder.countKitUnits === 'function' ? builder.countKitUnits(cart) : 0);
      var added = wanted > 0 && units >= unitsBefore + wanted;
      if (!added) {
        resetBuilder(builder, btn, cart, false);
        if (typeof builder.showError === 'function') builder.showError('Something went wrong. Please try again.');
        return done();
      }
      var p = plan(cart, units, tiers);
      var pb = planBody(p);
      var body = pb ? pb.body : {};
      if (drawerEl()) body.sections = drawerSection();
      return xhrJSON('POST', root() + 'cart/update.js', body).then(null, function () { return cart; }).then(function (updated) {
        if (pb && p.marker) setHint(p.marker !== MARK_OFF);
        syncCookie(updated, units, tiers);
        if (!isAdding(builder, btn)) return done(); /* the builder finished meanwhile */
        resetBuilder(builder, btn, updated, true);
        if (updated.sections) renderCart(updated);
        else document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: updated, openMiniCart: true } }));
        openDrawer();
        done();
      });
    }).catch(function () {
      resetBuilder(builder, btn, null, false);
      done();
    });
  }

  /* (2026-09-30 pm4) Fast path. Builder semantics kept: the tier comes from ALL kit units in the cart
     after the add, non-Realtor shopper codes are kept (system codes dropped), marker = tier. Returns
     false (builder's own flow runs) whenever its preconditions aren't met. */
  function fastAdd(builder, btn, event) {
    var settings = (window.themeVariables && window.themeVariables.settings) || {};
    if (settings.cartType === 'page' || settings.pageType === 'cart' || !drawerEl()) return false;
    if (builder.offerExpired || !Array.isArray(builder.tiers)) return false;
    if (builder.activeTier && builder.activeTier.discount > 0 && !builder.activeTier.code) return false;
    var items = builder.cards.filter(function (it) { return it.available && it.quantity > 0; })
      .map(function (it) { return { id: it.id, quantity: it.quantity }; });
    if (!items.length) return false;

    event.preventDefault();
    event.stopImmediatePropagation();
    var originalText = btn.textContent;
    btn.disabled = true;
    btn.textContent = builder.addingButtonText || 'Adding to cart…';
    if (typeof builder.clearError === 'function') builder.clearError();

    var cfg = getConfig();
    var tiers = cfg.tiers;
    var section = drawerSection();
    var fail = function (message) {
      if (typeof builder.showError === 'function') builder.showError(message || 'Something went wrong. Please try again.');
      btn.disabled = false;
      btn.textContent = originalText;
    };

    timeBox(fetch(root() + 'cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items, sections: section })
    }).then(function (r) {
      return r.json().then(function (j) { return { ok: r.ok, j: j }; }, function () { return { ok: r.ok, j: {} }; });
    })).then(function (res) {
      if (!res.ok) {
        fail((res.j && (res.j.description || res.j.message)) || 'One or more packages could not be added to the cart.');
        return;
      }
      /* 1) drawer now: render the returned section in place and open it; reset the builder */
      var html = res.j && res.j.sections && (res.j.sections[section] || res.j.sections['mini-cart']);
      if (html) patchDrawer(html);
      builder.cards.forEach(function (it) { it.quantity = 0; if (it.input) it.input.value = 0; });
      try { builder.updateAll(); } catch (e) { btn.disabled = false; btn.textContent = originalText; }
      openDrawer();
      busy = true; /* our follow-up owns the cart for a moment */

      /* 2) tier right after (never blocks the drawer): one update, one in-place patch */
      return timeBox(Promise.all([getProductIds(cfg), getJSON(root() + 'cart.js')]).then(function (both) {
        var ids = both[0];
        var cart = both[1];
        var units = ids.length ? kitUnits(cart, ids) : builder.countKitUnits(cart);
        if (typeof builder.countKitUnits === 'function') builder.cartKitUnits = builder.countKitUnits(cart);
        var want = tierCodeFor(units, tiers);
        var codes = cartCodes(cart);
        var keep = codes.filter(function (c) { return !isRealtorCode(c, tiers) && !(units && isSystemCode(c, tiers)); });
        var next = want ? keep.concat(want) : keep;
        var body = { sections: section, attributes: {} };
        body.attributes[MARK_ATTR] = want;
        if (next.join(',') !== codes.join(',')) body.discount = next.join(',');
        if (want) setHint(true);
        return postUpdate(body).then(function (updated) {
          var final = updated && typeof updated.item_count === 'number' ? updated : cart;
          /* (2026-10-09) The tier lost to an applicable page-offer code: marker off (one more update). */
          var lost = plan(final, units, tiers);
          var off = lost && lost.marker === MARK_OFF && lost.markerWas !== MARK_OFF ? planBody(lost) : null;
          if (!off || off.discountChanges) return final;
          off.body.sections = section;
          setHint(false);
          return postUpdate(off.body).then(function (u) { return u && typeof u.item_count === 'number' ? u : final; }, function () { return final; });
        }).then(function (final) {
          syncCookie(final, units, tiers);
          renderCart(final); /* in-place patch + cart:updated (counts, nudge, builder in-cart count) */
        });
      })).catch(function () {
        /* tier step failed / timed out: the regular reconcile picks the cart up */
        schedule(0);
      }).then(function () { busy = false; });
    }).catch(function () {
      /* add request failed or timed out: check what actually happened, never leave the button stuck */
      rescueBuilder(builder, btn, items.reduce(function (s, it) { return s + it.quantity; }, 0), Number(builder.cartKitUnits) || 0);
    });
    return true;
  }

  document.addEventListener('click', function (event) {
    var btn = event.target && event.target.closest && event.target.closest('[data-add-to-cart]');
    if (!btn || btn.disabled) return;
    var builder = builderOf(btn);
    if (!builder) return;
    try { if (fastAdd(builder, btn, event)) return; } catch (e) { /* fall through to the builder's own flow */ }
    var wanted = 0;
    try { wanted = builder.cards.reduce(function (sum, it) { return sum + (it.available && it.quantity > 0 ? it.quantity : 0); }, 0); } catch (e) {}
    var unitsBefore = Number(builder.cartKitUnits) || 0;
    var ids = knownIds(getConfig());
    if (ids && lastCart && Array.isArray(lastCart.items)) unitsBefore = kitUnits(lastCart, ids);
    var left = false;
    var onHide = function () { left = true; };
    window.addEventListener('pagehide', onHide, { once: true });
    setTimeout(function () {
      window.removeEventListener('pagehide', onHide);
      if (left || !isAdding(builder, btn)) return;
      rescueBuilder(builder, btn, wanted, unitsBefore);
    }, WATCH_MS);
  }, true);

  /* Back from checkout / cart restores the page from bfcache with the builder mid-add: reset it. */
  window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    Array.prototype.forEach.call(document.querySelectorAll('[data-add-to-cart]'), function (btn) {
      var builder = builderOf(btn);
      if (builder && isAdding(builder, btn)) resetBuilder(builder, btn, null, false);
    });
  });

  window.__ptRealtorKit = { reconcile: reconcile, tierCodeFor: tierCodeFor, plan: plan };
})();

/* ==========================================================================
 * Clarity 2026-10-07 batch, item 1 + 4: PDP zoom lightbox dead taps
 * (Sienna 140 / AromaMist 11 "blank element" dead clicks, all mobile).
 * Root cause: tapping a product photo on a phone opens Focal's PhotoSwipe zoom, but
 *  (a) the slide is blank white until the full-size file downloads, because Focal
 *      passes the media wrapper <div> as the PhotoSwipe placeholder (msrc), so there
 *      is no low-res image to show meanwhile; the <img> also has no alt for ~2s;
 *  (b) a single tap inside the lightbox does nothing on touch (Focal only handles
 *      mouse clicks there; touch needs double-tap or pinch).
 * Fix: seed msrc with the gallery image that is already loaded, set the alt
 * right away, single tap on the photo toggles zoom (same as double-tap), single
 * tap on the empty backdrop closes the lightbox.
 * APPEND-ONLY. Does NOT rewrite theme.js.
 * ========================================================================== */
(function () {
  if (window.__ptZoomTapPatched) return;
  window.__ptZoomTapPatched = true;

  function patch(Z) {
    if (!Z || Z.prototype.__ptZoomPatched) return;
    Z.prototype.__ptZoomPatched = true;

    var origBuild = Z.prototype._buildItems;
    if (typeof origBuild === 'function') {
      Z.prototype._buildItems = function () {
        var self = this;
        return Promise.resolve(origBuild.apply(this, arguments)).then(function (items) {
          try {
            var cells = self.mediaElement.querySelectorAll('.product__media-item[data-media-type="image"]:not(.is-filtered)');
            (items || []).forEach(function (item, i) {
              var img = cells[i] && cells[i].querySelector('img');
              if (img && typeof item.msrc !== 'string') item.msrc = img.currentSrc || img.src;
            });
          } catch (e) {}
          return items;
        });
      };
    }

    var origOpen = Z.prototype._openPhotoSwipe;
    if (typeof origOpen === 'function') {
      Z.prototype._openPhotoSwipe = function () {
        var self = this;
        return Promise.resolve(origOpen.apply(this, arguments)).then(function (result) {
          try {
            var ps = self.photoSwipeInstance;
            var setAlt = function () {
              var item = ps && ps.currItem;
              if (!item || !item.container) return;
              Array.prototype.forEach.call(item.container.querySelectorAll('img'), function (img) {
                if (!img.getAttribute('alt')) img.setAttribute('alt', item.alt || '');
              });
            };
            setAlt();
            ps.listen('afterChange', setAlt);
            ps.listen('imageLoadComplete', setAlt);
          } catch (e) {}
          return result;
        });
      };
    }
  }

  if (window.customElements) {
    var Z = customElements.get('product-image-zoom');
    if (Z) patch(Z);
    else customElements.whenDefined('product-image-zoom').then(function () { patch(customElements.get('product-image-zoom')); });
  }

  /* PhotoSwipe already delays touch taps by 300ms and drops them on double-tap,
     so a single tap here never fights the built-in double-tap zoom. */
  document.addEventListener('pswpTap', function (event) {
    var d = event.detail || {};
    if (d.pointerType === 'mouse') return;
    var target = event.target;
    if (!target || !target.closest) return;
    var zoomEl = target.closest('product-image-zoom');
    var ps = zoomEl && zoomEl.photoSwipeInstance;
    if (!ps || !ps.currItem) return;
    if (target.closest('button, a, .pswp__ui')) return;
    if (target.closest('.pswp__img')) {
      var initial = ps.currItem.initialZoomLevel;
      var max = (window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.mobileZoomFactor) || 2;
      if (ps.getZoomLevel() !== initial) ps.zoomTo(initial, d.releasePoint, 333);
      else ps.zoomTo(initial < 0.7 ? 1 : max, d.releasePoint, 333);
      return;
    }
    if (target.closest('.pswp__item, .pswp__container, .pswp__scroll-wrap, .pswp__bg')) ps.close();
  });
})();

/* ==========================================================================
 * Clarity 2026-10-07 batch, item 5: Chatty "Don't miss out / Get discounts"
 * welcome popup (10 mobile dead clicks on /collections/aroma-samples).
 * Root cause: the Chatty app styles the whole popup card with cursor:pointer,
 * but only its "Yes, sure!" button opens the chat/subscribe form; tapping the
 * message text does nothing (same on every page, live and preview).
 * Fix: a tap anywhere on the card (except its buttons) presses "Yes, sure!".
 * App markup only; no Chatty settings changed. APPEND-ONLY.
 * ========================================================================== */
(function () {
  if (window.__ptChattyTeaserTap) return;
  window.__ptChattyTeaserTap = true;
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var card = target.closest('.Avada-FaqsWelcomePopup__Container');
    if (!card || target.closest('button, a, input, textarea, select')) return;
    var cta = card.querySelector('.Avada-FaqsWelcomePopup_Primary-Button');
    if (cta) cta.click();
  });
})();

/* ==========================================================================
 * Follow-up 2026-10-07: PDP zoom lightbox console errors (Sienna, live + preview).
 * 1) "Cannot read properties of null (reading 'querySelector')" at theme.js:5391.
 *    Focal's _openPhotoSwipe sets a 2 s timer on every slide change to re-set the
 *    image alt via currItem.container. If the lightbox is closed within those 2 s
 *    (close button, Esc, backdrop tap), PhotoSwipe's destroy has already set
 *    item.container = null, so the timer throws. Not a markup/setting gap; every
 *    product with zoom does it, Sienna just gets the most zoom traffic.
 * 2) "Cannot read properties of null (reading 'beforeChange')" in photoswipe.js.
 *    Focal's PhotoSwipeUi binds close/prev/next/dot click handlers on the lightbox
 *    DOM (which is reused) at every open and only unbinds pswpTap on close. From the
 *    2nd open on, a tap on an arrow/dot also runs the old handlers against the
 *    destroyed instance(s).
 * Fix (no theme.js edit): when an instance is destroyed, give its last item an
 * empty detached container (the timer then finds no <img> and does nothing) and
 * destroy that instance's UI click delegate. Items/UI are rebuilt on every open.
 * APPEND-ONLY.
 * ========================================================================== */
(function () {
  if (window.__ptZoomDestroyPatched) return;
  window.__ptZoomDestroyPatched = true;

  function patch(Z) {
    if (!Z || Z.prototype.__ptZoomDestroyPatched) return;
    Z.prototype.__ptZoomDestroyPatched = true;
    var origOpen = Z.prototype._openPhotoSwipe;
    if (typeof origOpen !== 'function') return;
    Z.prototype._openPhotoSwipe = function () {
      var self = this;
      return Promise.resolve(origOpen.apply(this, arguments)).then(function (result) {
        try {
          var ps = self.photoSwipeInstance;
          if (ps && !ps.__ptDestroyHook) {
            ps.__ptDestroyHook = true;
            ps.listen('destroy', function () {
              try {
                if (ps.currItem && !ps.currItem.container) ps.currItem.container = document.createElement('div');
                if (ps.ui && ps.ui.delegate && typeof ps.ui.delegate.destroy === 'function') ps.ui.delegate.destroy();
              } catch (e) {}
            });
          }
        } catch (e) {}
        return result;
      });
    };
  }

  if (window.customElements) {
    var Z = customElements.get('product-image-zoom');
    if (Z) patch(Z);
    else customElements.whenDefined('product-image-zoom').then(function () { patch(customElements.get('product-image-zoom')); });
  }
})();

/* ==========================================================================
 * Canonical product links (2026-10-07, preview): product cards now link to
 * /products/<handle> instead of /collections/<c>/products/<handle>, so the PDP
 * no longer has a `collection` in context. The Liquid breadcrumb in
 * main-product.liquid already falls back to the product's primary/first real
 * collection (P3-5). This adds the "where did I come from" trail: when a shopper
 * clicks a product on a collection page, remember that collection (tab-scoped
 * sessionStorage); on that product's PDP, if the referrer is that collection
 * page, show it as the middle breadcrumb (e.g. Home / Diffusers / Sienna).
 * No extra requests. Display only; URLs and structured data are unchanged.
 * APPEND-ONLY.
 * ========================================================================== */
(function () {
  if (window.__ptCanonBreadcrumb) return;
  window.__ptCanonBreadcrumb = true;
  var KEY = 'ptBcFrom';
  var path = location.pathname.replace(/\/+$/, '');
  var collMatch = path.match(/^\/collections\/([^\/]+)$/);
  var prodMatch = path.match(/^\/products\/([^\/]+)$/);

  function collectionTitle() {
    try {
      var nodes = document.querySelectorAll('script[type="application/ld+json"]');
      for (var i = 0; i < nodes.length; i++) {
        var data = JSON.parse(nodes[i].textContent);
        if (data && data['@type'] === 'BreadcrumbList' && data.itemListElement && data.itemListElement[1] && data.itemListElement[1].name) {
          return String(data.itemListElement[1].name);
        }
      }
    } catch (e) {}
    var h1 = document.querySelector('h1');
    return h1 ? h1.textContent.trim() : '';
  }

  if (collMatch) {
    document.addEventListener('click', function (event) {
      var a = event.target && event.target.closest && event.target.closest('a[href*="/products/"]');
      if (!a) return;
      var m;
      try { m = new URL(a.href, location.href); } catch (e) { return; }
      if (m.origin !== location.origin) return;
      var hm = m.pathname.match(/\/products\/([^\/?#]+)/);
      if (!hm) return;
      var title = collectionTitle();
      if (!title) return;
      try {
        sessionStorage.setItem(KEY, JSON.stringify({ p: decodeURIComponent(hm[1]), u: path, t: title, ts: Date.now() }));
      } catch (e) {}
    }, true);
    return;
  }

  if (!prodMatch) return;
  var from = null;
  try { from = JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (e) {}
  if (!from || from.p !== decodeURIComponent(prodMatch[1]) || !from.u || !from.t) return;
  if (Date.now() - (from.ts || 0) > 30 * 60 * 1000) return;
  var ref = null;
  try { ref = document.referrer ? new URL(document.referrer) : null; } catch (e) {}
  if (!ref || ref.origin !== location.origin || ref.pathname.replace(/\/+$/, '') !== from.u) return;

  function apply() {
    var list = document.querySelector('nav.breadcrumb .breadcrumb__list');
    if (!list) return;
    var items = list.querySelectorAll('.breadcrumb__item');
    if (items.length < 2) return;
    var current = items[items.length - 1];
    var middle = items.length >= 3 ? items[items.length - 2] : null;
    var link = middle && middle.querySelector('a.breadcrumb__link');
    if (link) {
      if (link.getAttribute('href') === from.u) return;
      link.setAttribute('href', from.u);
      link.textContent = from.t;
    } else {
      var li = document.createElement('li');
      li.className = 'breadcrumb__item';
      var a = document.createElement('a');
      a.className = 'breadcrumb__link';
      a.setAttribute('href', from.u);
      a.textContent = from.t;
      li.appendChild(a);
      list.insertBefore(li, current);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply);
  else apply();
})();

/* ==========================================================================
 * Follow-up 2026-10-07 (QA): PDP zoom lightbox blanks on an early PREV/NEXT click.
 * Root cause (stock Focal + PhotoSwipe, live too): PhotoSwipe only fills the two
 * neighbour slides when its opening zoom-in animation ends ("initialZoomInEnd").
 * Focal's arrow/dot buttons are clickable from the first frame (the UI is just
 * faded), so a click during the opening animation moves to a slide that has no
 * content/size yet: photoswipe.js throws "reading 'center'" (called from
 * theme.js _goToPrev/_goToNext), the slide stays blank, and closing afterwards
 * throws more. Not wrap-around math (goTo wraps first->last correctly once ready).
 * Fix: while the opening animation runs, hold arrow/dot clicks (several clicks add
 * up) and replay them as soon as it ends (normally < 0.4 s). No theme.js edit.
 * APPEND-ONLY.
 * ========================================================================== */
(function () {
  if (window.__ptZoomEarlyNavGuard) return;
  window.__ptZoomEarlyNavGuard = true;

  /* Focal's UI drops .pswp__ui--hidden in the same "initialZoomInEnd" event in which
     PhotoSwipe fills the neighbour slides, so it is an exact "ready" signal. */
  function ready(zoomEl) {
    var ui = zoomEl.querySelector('.pswp__ui');
    return !ui || !ui.classList.contains('pswp__ui--hidden');
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;
    var btn = target.closest('[data-action="pswp-prev"], [data-action="pswp-next"], [data-action="pswp-move-to"]');
    if (!btn) return;
    var zoomEl = btn.closest('product-image-zoom');
    var ps = zoomEl && zoomEl.photoSwipeInstance;
    if (!ps || !zoomEl.open || (!zoomEl.__ptPendingNav && ready(zoomEl))) return; /* normal case: Focal handles it */

    event.preventDefault();
    event.stopImmediatePropagation();
    var action = btn.getAttribute('data-action');
    var pending = zoomEl.__ptPendingNav;
    if (!pending || pending.ps !== ps) {
      pending = zoomEl.__ptPendingNav = { ps: ps, steps: 0, dot: -1, started: Date.now() };
      (function retry() {
        if (zoomEl.__ptPendingNav !== pending) return;
        if (zoomEl.photoSwipeInstance !== ps || !zoomEl.open) { zoomEl.__ptPendingNav = null; return; }
        if (!ready(zoomEl)) {
          if (Date.now() - pending.started < 2000) setTimeout(retry, 40);
          else zoomEl.__ptPendingNav = null;
          return;
        }
        zoomEl.__ptPendingNav = null;
        try {
          if (pending.dot > -1) ps.goTo(pending.dot);
          for (var k = 0; k < Math.abs(pending.steps); k++) { if (pending.steps < 0) ps.prev(); else ps.next(); }
        } catch (e) {}
      })();
    }
    if (action === 'pswp-prev') pending.steps -= 1;
    else if (action === 'pswp-next') pending.steps += 1;
    else { pending.dot = Array.prototype.indexOf.call(btn.parentNode.children, btn); pending.steps = 0; }
  }, true);
})();

/* ==========================================================================
 * Realtor tier scope fix (2026-10-09). APPEND-ONLY.
 * Bug: the Realtors tier module above falls back to DEFAULT_COLLECTION
 * 'realtor-collection' (9 products: the 4 scent kits PLUS Best Sellers Trio,
 * Spire Diffuser, Room Spray, Surface Cleaner, Gift Card) whenever the browser
 * has no builder config, i.e. for every shopper who never opened /pages/realtors.
 * A Start Here cart with Best Sellers Trio or Spire then counted as a "kit
 * cart", the page-offer code (3KWND4F9M926) was swapped for Realtor_Kit_1,
 * which only applies to the scent kits, so the shopper got no discount.
 * Fix: publish the Realtors builder's own scope (collection 'scent-staging',
 * the 4 scent-kit products) as the config, so only real scent kits count as
 * kit units. Runs before any tier work (that is all async). The builder on
 * /pages/realtors still publishes its own config, which wins; a stored copy is
 * reused only when it was written for the same collection.
 * Keep KIT_IDS / tiers in step with the Realtors builder block settings
 * (templates/page.realtors.json, collection scent-staging).
 * ========================================================================== */
(function () {
  if (window.__ptRealtorScopeFix) return;
  window.__ptRealtorScopeFix = true;

  var KIT_COLLECTION = 'scent-staging';
  /* CALM WATERS, LUXE GARDEN, BLUE LAVA, RETREAT - Scent Kit */
  var KIT_IDS = ['15399834124515', '15399827177699', '15399824064739', '15399821377763'];
  var TIERS = [
    { quantity: 1, discount: 10, code: 'Realtor_Kit_1' },
    { quantity: 3, discount: 20, code: 'Realtor_Kit_2' },
    { quantity: 7, discount: 25, code: 'Realtor_Kit_3' },
    { quantity: 10, discount: 30, code: 'Realtor_Kit_4' }
  ];

  function valid(cfg) {
    return !!(cfg && Array.isArray(cfg.tiers) && cfg.tiers.length &&
      Array.isArray(cfg.productIds) && cfg.productIds.length);
  }

  /* The builder on this page already published its config: leave it. */
  if (valid(window.__ptRealtorKitConfig)) return;

  var stored = null;
  try { stored = JSON.parse(window.localStorage.getItem('pt-realtor-kit-config-v1') || 'null'); } catch (e) { stored = null; }

  window.__ptRealtorKitConfig = valid(stored) && stored.collection === KIT_COLLECTION
    ? stored
    : { v: 1, collection: KIT_COLLECTION, productIds: KIT_IDS.slice(), tiers: TIERS.slice() };
})();

/* ==========================================================================
 * PT: auto-complete impossible variant combinations (Clarity Oct 2026).
 * On products where an option value only exists with some other values
 * (e.g. Surface Cleaner "Waterfall" is 32oz only), picking it left the form
 * on a non-existent combo: variant id undefined, ADD TO CART disabled,
 * and taps on it were dead/rage clicks. When a change resolves to no
 * variant, select the first available value in the other option(s),
 * else the first other value (so a sold-out item shows Sold out).
 * Theme-only, no theme.js change; one retry per user change.
 * ========================================================================== */
(function () {
  if (window.__ptComboFix) return;
  window.__ptComboFix = true;
  var last = null, busy = false;
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('input[data-option-position]') && !busy) last = t;
  }, true);
  document.addEventListener('variant:changed', function (e) {
    var v = e.detail && e.detail.variant;
    if (busy || !last || (v && v.id)) return;
    var formId = last.getAttribute('form'), changedName = last.name;
    setTimeout(function () {
      var inputs = document.querySelectorAll('input[data-option-position][form="' + formId + '"]');
      var groups = {};
      Array.prototype.forEach.call(inputs, function (i) {
        if (i.name === changedName || i.type !== 'radio') return;
        (groups[i.name] = groups[i.name] || []).push(i);
      });
      var pick = null, fallback = null;
      Object.keys(groups).some(function (n) {
        groups[n].some(function (i) { if (!i.checked && !fallback) fallback = i; });
        return groups[n].some(function (i) {
          var wrap = i.parentElement;
          if (!i.checked && wrap && !wrap.classList.contains('is-disabled')) { pick = i; return true; }
          return false;
        });
      });
      /* Nothing in stock: still land on a real (sold-out) variant so the
       * button reads Sold out instead of a dead ADD TO CART. */
      pick = pick || fallback;
      if (!pick) return;
      busy = true;
      var lbl = document.querySelector('label[for="' + pick.id + '"]');
      (lbl || pick).click();
      setTimeout(function () { busy = false; last = null; }, 1500);
    }, 400);
  });
})();

/* ------------------------------------------------------------------
 * Cart60 upsell (2026-10-14): snippets/pt-cart-upsell.liquid.
 * Separate scent / size selects; only available variants are listed
 * (Liquid) and the size select is re-filtered per scent here, so
 * sold-out or missing combos (Waterfall) never show. Add is one-time
 * via /cart/add.js (no selling_plan). Drawer: Focal cart:updated +
 * cart:refresh with the mini-cart section. /cart: reload (Focal's own
 * cart-page pattern). Delegated listeners survive drawer re-renders.
 * Halloween free-oil picker: [data-pt-cart-gift-slot], not touched here.
 * ------------------------------------------------------------------ */
(function () {
  if (window.__ptCart60Upsell) return;
  window.__ptCart60Upsell = true;

  function variantsOf(item) {
    if (item.__ptVariants) return item.__ptVariants;
    var el = item.querySelector('[data-pt-upsell-variants]');
    var list = [];
    try { list = JSON.parse(el ? el.textContent : '[]') || []; } catch (e) { list = []; }
    item.__ptVariants = list.filter(Boolean);
    return item.__ptVariants;
  }

  function sync(item, changedIndex) {
    var variants = variantsOf(item);
    var selects = Array.prototype.slice.call(item.querySelectorAll('[data-pt-upsell-option]'));
    var btn = item.querySelector('[data-pt-upsell-add]');
    var price = item.querySelector('[data-pt-upsell-price]');
    if (!selects.length || !btn) return;
    /* re-filter later selects against earlier choices */
    selects.forEach(function (sel, i) {
      if (i === 0 || (typeof changedIndex === 'number' && i <= changedIndex)) return;
      var prior = selects.slice(0, i).map(function (s) { return s.value; });
      var firstOk = null;
      Array.prototype.forEach.call(sel.options, function (opt) {
        var ok = variants.some(function (v) {
          for (var k = 0; k < prior.length; k += 1) if (v.o[k] !== prior[k]) return false;
          return v.o[i] === opt.value;
        });
        opt.hidden = !ok;
        opt.disabled = !ok;
        if (ok && firstOk === null) firstOk = opt.value;
      });
      var cur = sel.options[sel.selectedIndex];
      if ((!cur || cur.disabled) && firstOk !== null) sel.value = firstOk;
    });
    var chosen = selects.map(function (s) { return s.value; });
    var match = variants.filter(function (v) {
      return chosen.every(function (val, k) { return v.o[k] === val; });
    })[0];
    if (match) {
      btn.setAttribute('data-variant-id', String(match.id));
      btn.disabled = false;
      if (price && match.p) price.textContent = match.p;
    } else {
      btn.disabled = true;
    }
  }

  function initAll(root) {
    (root || document).querySelectorAll('[data-pt-upsell-item]').forEach(function (item) {
      if (item.__ptInit) return;
      item.__ptInit = true;
      sync(item);
    });
  }

  document.addEventListener('change', function (event) {
    var sel = event.target && event.target.closest && event.target.closest('[data-pt-upsell-option]');
    if (!sel) return;
    var item = sel.closest('[data-pt-upsell-item]');
    if (item) sync(item, parseInt(sel.getAttribute('data-pt-upsell-option'), 10));
  });

  document.addEventListener('click', function (event) {
    var btn = event.target && event.target.closest && event.target.closest('[data-pt-upsell-add]');
    if (!btn || btn.disabled) return;
    event.preventDefault();
    var id = parseInt(btn.getAttribute('data-variant-id'), 10);
    if (!id) return;
    var block = btn.closest('[data-pt-upsell]');
    var status = block && block.querySelector('[data-pt-upsell-status]');
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    if (status) status.textContent = '';
    var sections;
    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }], sections: ['mini-cart'] })
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok) throw new Error((data && (data.description || data.message)) || 'Could not add this item.');
          sections = data && data.sections;
        });
      })
      .then(function () {
        if (window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.pageType === 'cart') {
          window.location.reload();
          return null;
        }
        return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        if (!cart) return;
        if (sections) cart.sections = sections;
        document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart, replacementDelay: 0 } }));
      })
      .catch(function (err) {
        btn.disabled = false;
        btn.removeAttribute('aria-busy');
        if (status) status.textContent = (err && err.message) || 'Could not add this item.';
      });
  });

  initAll(document);
  document.documentElement.addEventListener('cart:refresh', function () { setTimeout(function () { initAll(document); }, 50); setTimeout(function () { initAll(document); }, 900); });
  document.addEventListener('DOMContentLoaded', function () { initAll(document); });
})();

/* ------------------------------------------------------------------
 * Cart60 pm (2026-10-14): phone toggle for the upsell (<990px).
 * Collapsed by default. Open state is kept in sessionStorage so it
 * survives the drawer re-render after an add and the /cart reload;
 * collapsing clears it. Desktop ignores it (list always shown by CSS).
 * ------------------------------------------------------------------ */
(function () {
  if (window.__ptCart60Toggle) return;
  window.__ptCart60Toggle = true;
  var KEY = 'ptUpsellOpen';
  function isOpen() { try { return window.sessionStorage.getItem(KEY) === '1'; } catch (e) { return false; } }
  function setOpen(v) { try { if (v) window.sessionStorage.setItem(KEY, '1'); else window.sessionStorage.removeItem(KEY); } catch (e) {} }
  function apply(root) {
    var open = isOpen();
    (root || document).querySelectorAll('[data-pt-upsell]').forEach(function (block) {
      block.classList.toggle('is-open', open);
      var btn = block.querySelector('[data-pt-upsell-toggle]');
      if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }
  document.addEventListener('click', function (event) {
    var btn = event.target && event.target.closest && event.target.closest('[data-pt-upsell-toggle]');
    if (!btn) return;
    event.preventDefault();
    setOpen(btn.getAttribute('aria-expanded') !== 'true');
    apply(document);
  });
  apply(document);
  document.addEventListener('DOMContentLoaded', function () { apply(document); });
  document.documentElement.addEventListener('cart:refresh', function () {
    setTimeout(function () { apply(document); }, 50);
    setTimeout(function () { apply(document); }, 900);
  });
})();
